import { Box, Input, Text } from "@chakra-ui/react";
import { EyebrowBadge, FormField, SectionCard } from "../components";
import type { FormData } from "../types";

interface Step5Props {
  data: FormData;
  updateData: (field: string, value: string | boolean) => void;
  fieldErrors: Record<string, string>;
}

export function Step5Billing({ data, updateData, fieldErrors }: Step5Props) {
  return (
    <Box spaceY={8}>
      <Box spaceY={3}>
        <EyebrowBadge stepId={5} />
        <Box spaceY={2}>
          <Text
            fontSize="3xl"
            fontWeight="bold"
            color="gray.900"
            letterSpacing="tight"
          >
            Facturación
          </Text>
          <Text fontSize="lg" color="gray.500" maxW="2xl">
            Define a dónde enviaremos los cobros y las alertas relacionadas con
            el servicio de Palomma.
          </Text>
        </Box>
      </Box>

      <SectionCard
        title="Destinatarios administrativos"
        description="Estos datos se usan para el frente financiero, no para atención al cliente."
      >
        <Box
          display="grid"
          gridTemplateColumns={{ base: "1fr", md: "1fr 1fr" }}
          gap={6}
        >
          <FormField
            label="Correo para facturación electrónica"
            error={fieldErrors.correoFacturacion}
          >
            <Input
              type="email"
              value={data.correoFacturacion}
              onChange={(e) => updateData("correoFacturacion", e.target.value)}
              placeholder="contabilidad@tudominio.com"
            />
          </FormField>
          <FormField
            label="WhatsApp para notificaciones financieras"
            error={fieldErrors.whatsappFacturacion}
          >
            <Input
              type="tel"
              value={data.whatsappFacturacion}
              onChange={(e) =>
                updateData("whatsappFacturacion", e.target.value)
              }
              placeholder="300 000 0000"
            />
          </FormField>
        </Box>
      </SectionCard>
    </Box>
  );
}
